@use 'style/utils';

$_CLASS-PREFIX: '.joy-snackbar';
$_snackbarWidth: 350px;

:host {
    --snackbar-bottom-space: var(--joy-core-spacing-8);
    --snackbar-color-links: var(--joy-color-secondary-50);
    --snackbar-content-color: default;
    --snackbar-width: #{$_snackbarWidth};

    --snackbar-transition-timing: var(--joy-transition-duration-long);

    display: block;
    position: fixed;
    bottom: var(--snackbar-bottom-space);
    right: var(--snackbar-bottom-space);
    z-index: var(--joy-core-z-index-snackbar); // need to tokenize this
    width: auto;
    @include utils.getFontProperties(primary-300);
    width: var(--snackbar-width);
    max-width: calc(100% - var(--joy-core-spacing-6) * 2);
}

:host(#{$_CLASS-PREFIX}__position___relative) {
    --snackbar-transition-timing: 0.01ms !important;

    position: relative;
    bottom: 0;
    z-index: 1;
    left: 0;
    transform: none;
}

@keyframes showAnimation {
    0% {
        transform: translateX(120%);
    }
    100% {
        transform: translateX(0);
    }
}

:host(.joy-snackbar--hiding) {
    animation: showAnimation var(--snackbar-transition-timing) forwards;
    animation-direction: reverse;
}

#{$_CLASS-PREFIX} {
    $_padding: var(--joy-core-spacing-4);

    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: $_padding;
    overflow: hidden;
    border-radius: var(--joy-core-radius-3);
    text-align: left;
    background-color: white;
    color: inherit;
    animation: showAnimation var(--snackbar-transition-timing);
    max-width: calc(100% - #{$_padding} * 2);
    width: calc(100% - #{$_padding} * 2);
    margin: auto;
    box-shadow: var(--joy-core-elevation-3);

    &:before {
        position: absolute;
        display: block;
        content: '';
        bottom: 0;
        left: 0;
        width: 100%;
        height: 4px;
        background-color: var(--snackbar-content-color);
    }

    &__heading {
        @include utils.getFontProperties(primary-650);

        & + * {
            margin-bottom: var(--joy-core-spacing-4);
        }
    }

    &__actions,
    > button {
        align-self: center;
    }

    &__img {
        display: inline-flex;
        margin-right: var(--joy-core-spacing-4);

        joy-icon {
            color: var(--snackbar-content-color);
        }
    }

    &__content {
        flex-grow: 1;
        padding-right: var(--joy-core-spacing-5);
        color: var(--joy-color-neutral-50);
        overflow-wrap: break-word;
        max-width: 100%;

        strong {
            display: block;
            width: 100%;
            font-weight: var(--joy-font-weight-bold);
        }

        a {
            color: var(--snackbar-color-links);
        }
    }

    &__close-icon {
        --icon-size: var(--joy-core-spacing-4);
        cursor: pointer;
    }

    &__trigger___action {
        display: block;
        width: 100%;
        margin: var(--joy-core-spacing-4) 0 0 0;
        color: var(--joy-color-secondary-30);
        cursor: pointer;

        &:hover {
            text-decoration: underline;
        }
    }

    &_info {
        --snackbar-content-color: var(--joy-color-information-50);
    }

    &_warning {
        --snackbar-content-color: var(--joy-color-warning-50);
    }

    &_error {
        --snackbar-content-color: var(--joy-color-error-50);
    }

    &_success {
        --snackbar-content-color: var(--joy-color-success-50);
    }
}
